// Copyright © 2021 Move Closer
import { AbstractTypeDriver } from './abstract';
import { RelatedType } from '../contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class AuthorDriver extends AbstractTypeDriver {
    constructor() {
        super(...arguments);
        /**
         * Key that stores RelatedType.
         * @protected
         */
        this.typeKey = RelatedType.Author;
    }
    /**
     * @inheritDoc
     */
    resolve(id, record, config, driverResolver) {
        const description = super.resolve(id, record, config, driverResolver);
        const fileDriver = driverResolver(RelatedType.File);
        let image;
        try {
            image = fileDriver.resolve(`${description.avatar.value}`, record, config);
        }
        catch (e) {
            image = undefined;
        }
        return {
            ...description,
            avatar: image
        };
    }
}
